export default __webpack_public_path__ + "static/media/project-three.c206affc.png";